const error404 = {
    title: 'Błąd 404',
    header: 'Nie znaleziono',
    message: "Trafiłeś na stronę, która nie istnieje",
    link: "Powrót na stronę główną",
}

export default error404
